<template>
  <div class="md-layout" :class="typeregister"> 
    <div class="md-layout-item">
      <div class="w-100">
          <md-button v-if="typeregister != 'gym'" class="md-button cursor-pointer bg-black text-white" @click="typeregister='gym'">
            {{ $t('register') }} | GoTakeIT Gym  <md-icon>fitness_center</md-icon>
          </md-button>
      </div>  

      <signup-card>
  <md-field class="menu-language registermenu" slot="title">
         <md-icon :class="typeregister == 'gym' ? 'text-white':' text-secondary'">language</md-icon>
                <md-select
                  class="md-white"
                  :class="typeregister == 'gym' ? 'text-white':' text-secondary'"
                  id="language-select"
                  v-model="selectedLanguage"
                  @md-selected="changeLanguage"
                >
                  <md-option value="en">English 🇬🇧</md-option>
                  <md-option value="es">Español 🇪🇸</md-option>
                  <md-option value="fr">Français 🇫🇷</md-option>
                  <md-option value="pt">Português 🇵🇹</md-option>
                  <md-option value="uk">Українська 🇺🇦</md-option>
                </md-select>
              </md-field>


        <div slot="title" class="logoregister">

          

  
          <a href="https://gotake.it/" v-if="typeregister == 'gym'" >
          <svg   viewBox="0 0 409.6666666666667 93" preserveAspectRatio="xMidYMid meet" class="css-88gl6m" id="ddacfdef"><defs id="SvgjsDefs1013"></defs><g id="SvgjsG1014" featurekey="symbolContainer" transform="matrix(1,0,0,1,0,0)" fill="#111">    <rect width="98" height="93"></rect></g><g id="SvgjsG1015" featurekey="monogramFeature-0" transform="matrix(1.4360743561155873,0,0,1.4360743561155873,17.84588846582662,-9.21221178152457)" fill="#fff"><path d="M23.28 60.6 c-12.9 0 -21.78 -10.56 -21.78 -21.84 c0 -13.68 10.02 -21.9 20.28 -21.9 c10.14 0 17.64 4.98 17.64 11.1 c0 2.94 -1.92 4.86 -4.8 4.86 c-7.74 0 -8.76 -11.7 -15.54 -11.7 c-4.26 0 -7.02 4.44 -7.02 10.5 c0 11.88 6.18 21.6 13.62 21.6 c1.5 0 2.58 -0.24 3.42 -0.6 l0 -7.86 c0 -2.82 -3.36 -3.48 -3.36 -5.16 l0 -0.24 c0 -0.72 0.72 -1.2 1.56 -1.2 l13.38 0.06 c0.9 0 1.44 0.48 1.44 1.2 l0 0.24 c0 1.68 -2.88 2.34 -2.88 5.16 l0 6.96 c0 1.74 -0.48 2.88 -2.52 4.5 c-2.64 2.1 -7.38 4.32 -13.44 4.32 z"></path></g><g id="SvgjsG1016" featurekey="nameFeature-0" transform="matrix(1.547139083686481,0,0,1.547139083686481,115.21515082973778,6.053186039050097)" fill="#fff"><path d="M28.92 25.92 c0.6 8.96 -5.52 14.48 -12.8 14.48 c-7.48 0 -14.32 -5.92 -14.32 -14.4 s7 -14.4 14.32 -14.4 c3.52 0 6.72 1.2 9.24 3.32 l-2.04 2.32 c-1.96 -1.56 -4.48 -2.48 -7 -2.48 c-5.72 0 -11.08 4.64 -11.08 11.24 s5.2 11.24 10.88 11.24 c4.96 0 8.92 -2.68 9.68 -8.44 l-8.16 0 l0 -2.88 l11.28 0 z M46.88 11.600000000000001 c7.28 0 14.32 5.92 14.32 14.4 s-7.04 14.4 -14.32 14.4 c-7.32 0 -14.32 -5.92 -14.32 -14.4 s7 -14.4 14.32 -14.4 z M46.88 37.24 c5.48 0 10.88 -4.64 10.88 -11.24 s-5.4 -11.24 -10.88 -11.24 c-5.52 0 -10.88 4.64 -10.88 11.24 s5.36 11.24 10.88 11.24 z M86.72 21.96 l-4.4 0 l0 13.4 c0 1.24 0.48 2 1.68 2 c1.04 0 1.8 -0.24 2.68 -0.64 l0 2.8 c-0.88 0.44 -1.92 0.72 -3.56 0.72 c-2.12 0 -4.04 -0.96 -4.04 -4.6 l0 -13.68 l-2.88 0 l0 -2.76 l2.88 0 l0 -4.88 l3.24 0 l0 4.88 l4.4 0 l0 2.76 z M99.96000000000001 18.84 c3.68 0 6.52 2.04 7.48 4.28 l0 -3.92 l3.28 0 l0 20.8 l-3.28 0 l0 -4 c-0.96 2.4 -3.8 4.4 -7.48 4.4 c-4.72 0 -10.44 -3.56 -10.44 -10.8 c0 -7.16 5.72 -10.76 10.44 -10.76 z M100.32000000000001 21.76 c-3.52 0 -7.6 2.6 -7.6 7.84 c0 5.28 4.08 7.88 7.6 7.88 c3.56 0 7.28 -2.52 7.28 -7.88 c0 -5.32 -3.72 -7.84 -7.28 -7.84 z M130.36 40 l-8.96 -9.28 l-2.84 3 l0 6.28 l-3.28 0 l0 -6.84 l0 -21.44 l3.28 0 l0 17.96 l9.84 -10.48 l3.96 0 l-8.88 9.32 l10.76 11.48 l-3.88 0 z M147.07999999999998 18.84 c4.72 0 11.04 3.6 10.2 11.96 l-17.56 0 c0.52 4.56 4.08 6.8 7.84 6.8 c2.88 0 4.72 -0.8 6.28 -2.32 l1.92 1.76 c-1.88 2.24 -4.6 3.36 -8.24 3.36 c-5.36 0 -11.08 -3.6 -11.08 -10.76 c0 -7.2 5.92 -10.8 10.64 -10.8 z M147.07999999999998 21.68 c-3.08 0 -6.76 2.2 -7.36 6.68 l14.68 0 c-0.4 -4.48 -4.2 -6.68 -7.32 -6.68 z M176.32 11.719999999999999 l0 2.92 l-3.28 0 l0 -2.92 l3.28 0 z M176.32 19.2 l0 20.8 l-3.28 0 l0 -20.8 l3.28 0 z M190.32 21.96 l-4.4 0 l0 13.4 c0 1.24 0.48 2 1.68 2 c1.04 0 1.8 -0.24 2.68 -0.64 l0 2.8 c-0.88 0.44 -1.92 0.72 -3.56 0.72 c-2.12 0 -4.04 -0.96 -4.04 -4.6 l0 -13.68 l-2.88 0 l0 -2.76 l2.88 0 l0 -4.88 l3.24 0 l0 4.88 l4.4 0 l0 2.76 z"></path></g></svg> 

          </a>
           
        </div>         

        <div
          class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 ml-auto d-none d-sm-block"
          slot="content-left"
          v-if="typeregister == 'food' && false"
        >
          <div
            class="info info-horizontal"
            v-for="item in contentLeft"
            :key="item.title"
          >
            <div :class="`icon ${item.colorIcon}`">
              <md-icon>{{ item.icon }}</md-icon>
            </div>
            <div class="description">
              <h4 class="info-title">{{ $t(item.title) }}</h4>
              <p class="description">{{ $t(item.description) }}</p>
            </div>
          </div>

          </div>
          <div
            class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 ml-auto d-none d-sm-block"
            slot="content-left"
            v-if="typeregister == 'gym' && false"
          >
          <div
            class="info info-horizontal"
            v-for="item in contentLeftGym"
            :key="item.title"
          >
            <div :class="`icon ${item.colorIcon}`">
              <md-icon>{{ item.icon }}</md-icon>
            </div>
            <div class="description">
              <h4 class="info-title">{{ $t(item.title) }}</h4>
              <p class="description">{{ $t(item.description) }}</p>
            </div>
          </div>
        </div>
        <div
          class="md-layout-item md-size-50 md-medium-size-50 md-small-size-100 mr-auto"
          slot="content-right"
          v-if="showconfirm"
        >
          <h2 class="my-2 mt-4 title text-center" slot="title">{{ $t('confirmEmail') }}</h2>
          <h4 class="my-2 align-center text-center text-white">{{ $t('confirmEmailText') }}</h4>
          <p class="text-white text-center">Si no encuentras el email verifica SPAM. Si no has recibido el email con el código no dudes en contactarnos para que podamos activar tu cuenta manualmente. Envíanos un email a contact@gotake.it o en nuestro Whatsapp de soporte técnico click aquí: <strong><a class="text-primary" href="https://chat.whatsapp.com/L32mTz6n8k08sHGvnDnvWU" target="_blank">Whatsapp</a></strong></p>
        </div>
        <div v-if="!showconfirm && typeregister"
          class="md-layout-item md-size-100 md-medium-size-100 md-small-size-100 mr-auto"
          slot="content-right"
        >
          <h5 class="my-2 title text-center" slot="title">{{ $t('register') }}</h5>
          

          <div v-if="typeregister == 'gym'" class="button-container" :class="typeregister == 'gym' ? 'text-white':' text-secondary'">
            <span class="mt-3 pl-3" >
             <md-icon class="text-white">start</md-icon> {{$t('seeDemoBeforeSignUp')}}
            </span>
          </div>
          <div v-if="typeregister == 'gym'" class="button-container" :class="typeregister == 'gym' ? 'text-white':' text-secondary'">
            <a class="border-primary border px-1 mt-2 border-white" href="https://gotakeitgym.app.gotake.it">{{$t('seeDemo')}}</a>
          </div>
          <md-field class="md-form-group">
            <md-icon>face</md-icon>
            <label>{{ $t('name') }}*</label>
            <md-input v-model="form.name" type="text" @input="clearError('name')"></md-input>
            <span v-if="errors.name" class="error">{{ errors.name }}</span>
          </md-field>
          <md-field class="md-form-group countryregister">
            <md-icon>public</md-icon>
            <CountrySelect 
              :usei18n="false"
            v-model="form.country" 
            :country="form.country" 
            @input="clearError('country')" 
            />
            <span v-if="errors.country" class="error">{{ errors.country }}</span>
          </md-field>
          <md-field class="md-form-group">
            <md-icon v-if="typeregister == 'gym'">business</md-icon>
            <md-icon v-else>restaurant</md-icon>
            <label v-if="typeregister == 'gym'">{{ $t('businessName') }}*</label>
            <label v-else>{{ $t('restaurantName') }}</label>
            <md-input v-model="form.restaurant" type="text" @change="checkRestaurantName" @input="clearError('restaurant')"></md-input>
            <i v-if="errors.restaurant" class="error">{{ errors.name }}</i>
            <i v-if="errors.restaurantexist" class="error">{{ errors.restaurantexist }}</i>
          </md-field>
           <small><md-icon class="text-primary sm-icon">circle</md-icon> <i class="text-primary">El nombre de tu negocio lo usaremos en la URL que tus clientes necesitarán para acceder a la aplicación.</i></small>
          <div>
            <span v-if="form.restaurant" class="text-secondary">https://{{ getUrlName() }}.app.gotake.it</span>
          </div>


          <md-field class="md-form-group">
            <md-icon>facebook</md-icon>
            <label>Link de tu negocio (opcional)</label>
            <md-input v-model="form.companyLink" type="text"></md-input>
          </md-field>
           <small><md-icon class="text-primary sm-icon">circle</md-icon> <i class="text-primary">Ingresa el link de instagram, facebook o sitio web de tu negocio para que podamos promocionarte en campañas de marketing.</i> </small>


          <md-field class="md-form-group">
            <md-icon>email</md-icon>
            <label>{{ $t('email') }}*</label>
            <md-input v-model="form.email" type="email" @input="clearError('email')"></md-input>
            <i v-if="errors.email" class="error">{{ errors.name }}</i>
            <i v-if="errorMessage" class="error">{{ errorMessage }}</i>
          </md-field>
          <small> <md-icon class="text-primary sm-icon">circle</md-icon> <i class="text-primary">Tenga en cuenta que le enviaremos un E-mail con un código para que usted pueda confirmar su cuenta.</i></small>

          <md-field class="md-form-group">
            <md-icon>lock_outline</md-icon>
            <label>{{ $t('password') }}*</label>
            <md-input v-model="form.password" type="password" @input="clearError('password')"></md-input>
            <span v-if="errors.password" class="error">{{ errors.name }}</span>
          </md-field>
          <md-field>
          <md-checkbox v-model="boolean">
            {{ $t('termsAndConditions') }}
          </md-checkbox> 
          <span class="text-primary mt-4"> 
            <a href="/#/terms" target="_blank" >{{ $t('termsLinkText') }}</a>
          </span>
          </md-field>
          <span v-if="errors.terms" class="error">{{ errors.terms }}</span>
          <div class="button-container">
            <md-button href class="md-primary md-round mt-4" slot="footer" @click="register"> {{ $t('getStarted') }}</md-button>
          </div>
          <div class="button-container" :class="typeregister == 'gym' ? 'text-white':' text-secondary'">
            <router-link class="mt-3 pl-3"  :to="{ path: '/login' }">
             <md-icon class="text-white">login</md-icon> {{ $t('login') }}
            </router-link>
          </div>
        </div>
      </signup-card>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import CountrySelect from 'vue-country-select';
import { registerAction, checkNameAction } from "@/pages/Auth/actions";
import { SignupCard } from "@/components";
import locales from '../../../locales/index.js';
import { i18n } from "@/i18n";
import permissionsMixin from '@/mixins/permissionsMixin';



export default {
  mixins: [permissionsMixin],
  components: {
    SignupCard,
  },
  computed: {

    languages() {
      return this.$languages;
    },
  },
    mounted() {
    
    this.form.country = 'AR';  // Aseguramos que Argentina sea seleccionada tras la carga del componente
  
   

  },
  created() {


    const currentUrl = window.location.href;
    const subdomainPattern = /^https:\/\/.*\.app\.gotake\.it(?:\/#)?\/register$/;

    if (subdomainPattern.test(currentUrl)) {
      window.location.href = 'https://app.gotake.it/register';
      return; // Detiene la ejecución del guard
    }
    
    if(this.$router.currentRoute.params.type){
      //this.typeregister = this.$router.currentRoute.params.type

    }
  

  },
  data() {
    return {
    typeregister: 'gym',
            selectedLanguage: "es",
      logo: '/img/gotakeit.png',
      boolean: false,
      errorMessage: false,
      showconfirm: false,
      form: {
        name: '',
        restaurant: '',
        email: '',
        password: '',
        country: 'AR'
      },
      errors: {
        name: null,
        restaurant: null,
        email: null,
        password: null,
        terms: null,
      },
      contentLeft: [
        {
          colorIcon: "icon-success",
          icon: "smartphone",
          title: "createApp",
          description: "createAppDesc",
        },
        {
          colorIcon: "icon-danger",
          icon: "add",
          title: "addProducts",
          description: "addProductsDesc",
        },
        {
          colorIcon: "icon-info",
          icon: "group",
          title: "customersEnjoy",
          description: "customersEnjoyDesc",
        },
      ],
      contentLeftGym: [
        {
          colorIcon: "icon-success",
          icon: "smartphone",
          title: "createApp",
          description: "createAppDesc",
        },
        {
          colorIcon: "icon-danger",
          icon: "add",
          title: "loadClients",
          description: "insertClients",
        },
        {
          colorIcon: "icon-info",
          icon: "group",
          title: "clientsStartUsing",
          description: "qrScanNotification",
        },
      ],
    };
  },
  methods: {
    changeLanguage() {
      
      localStorage.setItem("language", this.selectedLanguage);
      i18n.locale = this.selectedLanguage;
    },
    clearError(field) {
      Vue.set(this.errors, field, null);
    },
    getUrlName(){
      return this.form.restaurant
        .toLowerCase() // Convertir a minúsculas
        .normalize("NFD") // Descomponer caracteres con acentos
        .replace(/[\u0300-\u036f]/g, "") // Eliminar marcas diacríticas
        .replace(/\s+/g, '') // Eliminar espacios
        .replace(/[^a-z0-9]/g, ''); // Eliminar caracteres especiales
    },
    validateEmail(email) {
      const re = /\S+@\S+\.\S+/;
      return re.test(email);
    },
    async checkRestaurantName() {
      this.clearError('restaurantexist');
      if (this.form.restaurant) {
        try {
          const res = await checkNameAction(this.form.restaurant);
          if (res.exists) {
            Vue.set(this.errors, 'restaurantexist', this.$t('nameAlreadyTaken'));
          }
          return false;
        } catch (error) {
          Vue.set(this.errors, 'restaurantexist', this.$t('errorCheckingRestaurantName'));
          return false;
        }
      }else{
       return false;
      }
      return true;
    },
    validateForm() {
      let valid = true;
      if (!this.form.name) {
        Vue.set(this.errors, 'name', this.$t('nameRequired'));
        valid = false;
      }
      if (!this.form.restaurant) {
        Vue.set(this.errors, 'restaurant', this.$t('restaurantNameRequired'));
        valid = false;
      } else if (this.errors.restaurant) {
        valid = false;
      }

      if (!this.form.country) {
        Vue.set(this.errors, 'country', this.$t('nameRequired'));
        valid = false;
      } else if (this.errors.country) {
        valid = false;
      }

      if(this.errors.restaurantexist){
       valid = false;
      }
      if (!this.form.email) {
        Vue.set(this.errors, 'email', this.$t('emailRequired'));
        valid = false;
      } else if (!this.validateEmail(this.form.email)) {
        Vue.set(this.errors, 'email', this.$t('emailInvalid'));
        valid = false;
      }
      if (!this.form.password) {
        Vue.set(this.errors, 'password', this.$t('passwordRequired'));
        valid = false;
      }
      if (!this.boolean) {
        Vue.set(this.errors, 'terms', this.$t('termsRequired'));
        valid = false;
      }
      return valid;
    },
    handleRegisterClick() {
      window.gtag_report_conversion("https://app.gotake.it/register/gym");
    },
    async register() {
      if (this.validateForm()) { 
        try {
          let role = 'restaurant';
          if(this.typeregister == 'food'){
            role = 'restaurant'
          }
          if(this.typeregister == 'gym'){
            role = 'gym'
          }

          const response = await registerAction(this.form.name, this.form.password, this.form.email, this.form.restaurant, this.form.country, role, this.form.companyLink);
          if (response.ok) {
            this.errorMessage = null;
            this.showconfirm = true;

            this.handleRegisterClick();

          } else {
            this.errorMessage = this.$t('userExists');
          }
        } catch (error) {
          this.errorMessage = this.$t('userExists');
        }
      }
    },
  },
};
</script>

<style>

.gym .md-field.md-theme-default > .md-icon:after {
    background-color: inherit !important;
}

.gym button .md-ripple{
  background-color: black !important;
}

.gym .md-card-signup {
  background: rgb(0, 0, 0, 0.5) !important;
}

.gym .title{
  color:white;
}
.gym .countryregister select {
    background: transparent;
    color: white;
}


.gym .title,
.gym a,
.gym .md-card-signup h2,
.gym .md-card-signup h4,
.gym .md-card-signup span,
.gym .md-card-signup input,
.gym .md-card-signup input::placeholder, {
  color:white !important;
}

.gym .md-field .md-input{
  -webkit-text-fill-color: white !important;
  
}

.gym .md-card-signup .md-checkbox-container{
  border-color:white !important;
}

.md-checkbox-container{
  margin-top: 8px;
    margin-left: 3px;
}
.logoregister {
  width: 200px;
  margin: 0 auto;
  margin-bottom: 15px;
}
.iconlogo{
   margin-top: -72px;
    margin-left: 201px;
}
.error {
  color: red;
  font-size: 12px;
}

.menu-language.registermenu {
    top: 0;
    right: 0;
    position: absolute;
    margin-top: 6px !important;
    margin-right: 8px !important;
    padding: 7px !important;
    width: min-content;
}


.menu-language.registermenu input{
      border: 0 !important;
    padding: 0  !important;  

    }
.menu-language {
    margin: 0 auto !important; 
    padding: 9px 15px !important;
}
.register-page .md-card-signup .md-checkbox {
    margin-top: 17px !important;
    margin-right: 4px  !important;
}

.menu-language.registermenu .md-input{
    height:25px !important;
    border: 1px solid #6d6d6d;
    border-radius: 7px;
    padding: 10px;
}

    .countryregister select{
        border: 0;
    margin-left: 9px;
        border-bottom: 1px solid #a2a2a2;
    width: 100%;
    }
   .countryregister select option[value=""] {
      color: #a2a2a2;
    }

@media screen and (max-width: 991px) {
 .register-page .md-card-signup {
    margin-top: 0;
    margin-bottom: 0;

  }
  .logoregister {
    margin-top: 30px;
  }
  .page-header > .container {
    color: #FFFFFF;
    padding-top: 70px;
    padding-bottom: 0;
  }
}

.itemtitle {
    margin-left: 160px;
    color: #11b5c9;
    font-family: 'Crisp Noto Sans Bold';
    display: block;
    margin-top: -18px;
}

i.sm-icon {
  font-size: 5px !important;
}

</style>
